export default {
  choose: {
    title: 'Retirer {{name}} comme propriétaire',
    title_no_owner: 'Choisir un propriétaire pour {{restaurant}}',
    description: 'Choisissez qui succède à {{name}}, ou laissez {{restaurant}} sans propriétaire pour le moment.',
    description_no_owner:
      '{{restaurant}} n’a pas de propriétaire. Choisissez un membre de l’équipe, ou une nouvelle personne.',
    new_owner: 'Nouveau propriétaire',
    previous_owner: '{{name}} après le changement',
  },
  options: {
    team: {
      title: 'Un membre de l’équipe',
      loading: "Chargement de l'équipe…",
      description_one: 'Tout opérateur ou employé, {{count}} personne.',
      description_other: 'Tout opérateur ou employé, {{count}} personnes.',
      empty: 'Il n’y a encore personne d’autre dans l’équipe.',
      search: 'Rechercher dans l’équipe par nom ou e-mail',
      no_match: 'Aucun membre de l’équipe ne correspond à « {{query}} ».',
    },
    new: {
      title: 'Une nouvelle personne',
      description: 'Elle devient propriétaire immédiatement et reçoit ses identifiants par e-mail.',
    },
    none: {
      title: 'Pas de propriétaire pour le moment',
      description: 'Choisissez un propriétaire plus tard. D’ici là, {{restaurant}} n’a pas de propriétaire.',
    },
    keep: {
      title: 'Reste dans l’équipe en tant qu’opérateur',
      description: 'Conserve l’accès aux restaurants qu’elle gère actuellement.',
    },
    remove: {
      title: 'Retiré de l’équipe',
      description: 'Perd immédiatement l’accès au tableau de bord.',
    },
  },
  roles: {
    operator: 'Opérateur',
    employee: 'Employé',
  },
  fields: {
    first_name: 'Prénom',
    last_name: 'Nom',
    email: 'E-mail',
  },
  email_errors: {
    invalid_email: 'Saisissez un e-mail valide, comme nom@exemple.com.',
    email_is_owner: '{{name}} est déjà propriétaire.',
    email_is_manager: '{{name}} fait déjà partie de l’équipe.',
    email_taken: 'Une personne extérieure à cette équipe se connecte déjà avec cet e-mail. Utilisez un autre e-mail.',
  },
  confirm: {
    title: 'Retirer {{name}} comme propriétaire ?',
    title_no_owner: 'Nommer {{name}} propriétaire ?',
    description_both: 'Les deux changements ont lieu ensemble. Si l’un échoue, rien ne change.',
    description: 'Vérifiez le changement avant de confirmer.',
  },
  summary: {
    none: '<b>{{restaurant}}</b> n’a pas de propriétaire tant que vous n’en choisissez pas un. Tout ce qui nécessite le propriétaire attend jusque-là.',
    new: '<b>{{name}}</b> devient immédiatement propriétaire de {{restaurant}}.',
    email:
      'Ses identifiants sont envoyés à <b>{{email}}</b>. Vérifiez l’adresse : toute personne qui y a accès peut se connecter en tant que propriétaire.',
    team: '<b>{{name}}</b> devient propriétaire de {{restaurant}}.',
    group_access:
      'En tant que propriétaire, elle accède à tous les restaurants de {{group}}, ce qui peut être plus qu’aujourd’hui.',
    keep: '<b>{{name}}</b> reste dans l’équipe en tant qu’opérateur.',
    remove: '<b>{{name}}</b> est retiré de l’équipe et ne peut plus se connecter.',
  },
  error: {
    title: 'Impossible de changer le propriétaire.',
    description: 'Rien n’a été modifié. Réessayez, ou contactez le support si le problème persiste.',
  },
  buttons: {
    close: 'Fermer',
    continue: 'Continuer',
    cancel: 'Annuler',
    back: 'Retour',
    remove_as_owner: 'Retirer comme propriétaire',
    make_owner: 'Nommer propriétaire',
    saving: 'Enregistrement…',
    try_again: 'Réessayer',
    choose_instead: 'Choisir {{name}} à la place',
    invite_instead: 'Inviter une nouvelle personne',
  },
};
